import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  paper: {
    margin: '20px 10px 20px 25px',
    padding: 0,
    background: 'transparent',
  },
  kpiContainer: {
    margin: '24px 104px',
  },
  tab: {
    textTransform: 'initial',
    color: '#2F2F2F',
    padding: '0 30px',
  },
  tabWrapper: {
    flexDirection: 'row',
    justifyContent: 'left',
  },
  tabSelected: {
    color: '#2188CC !important',
    background: '#E9EBED 0% 0% no-repeat padding-box',
    borderRadius: '12px 12px 0px 0px',
  },
}));

export default useStyles;
